import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=432f5df8&scoped=true"
import script from "./Legals.vue?vue&type=script&lang=js"
export * from "./Legals.vue?vue&type=script&lang=js"
import style0 from "./Legals.vue?vue&type=style&index=0&id=432f5df8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f5df8",
  null
  
)

export default component.exports